import { useEffect, useState } from 'react';
import { onSession, type SessionUser } from '../services/auth';

/** Subscribes to the auth session; returns the domain user (with role claim) and a loading flag. */
export function useSession(): { user: SessionUser | null; loading: boolean } {
  const [user, setUser] = useState<SessionUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(
    () =>
      onSession((u) => {
        setUser(u);
        setLoading(false);
      }),
    [],
  );

  return { user, loading };
}
